import "./css/Loader.css"; // Import the CSS with animation styles

export const Loader = () => {
  return (
    <div className="flex mt-[5rem] justify-center items-center w-full h-screen">
      <div className="w-1/4 h-1/2 flex justify-center items-center relative">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 500 500"
          className="w-full h-full"
          style={{ transformOrigin: "center center" }}
        >
          <defs>
            <clipPath id="clipPath">
              <rect width="500" height="500"></rect>
            </clipPath>
          </defs>
          <g clipPath="url(#clipPath)">
            {/* First square (top-left) */}
            <rect
              x="100"
              y="100"
              width="57"
              height="57"
              className="fill-indigo-500 animate-move-square"
            />
            {/* Second square (top-right) */}
            <rect
              x="200"
              y="100"
              width="57"
              height="57"
              className="fill-blue-400 animate-move-square"
            />
            {/* Third square (bottom-right) */}
            <rect
              x="200"
              y="200"
              width="57"
              height="57"
              className="fill-indigo-500 animate-move-square"
            />
            {/* Fourth square (bottom-left) */}
            <rect
              x="100"
              y="200"
              width="57"
              height="57"
              className="fill-blue-400 animate-move-square"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};
